/// <reference types="./styles.d.mts" />
import * as $a from "../../../../../lustre/lustre/attribute.mjs";
import * as $css from "../../../../../sketch/sketch/css.mjs";
import * as $angle from "../../../../../sketch/sketch/css/angle.mjs";
import * as $length from "../../../../../sketch/sketch/css/length.mjs";
import { percent, px } from "../../../../../sketch/sketch/css/length.mjs";
import * as $transform from "../../../../../sketch/sketch/css/transform.mjs";
import * as $html from "../../../../../sketch_lustre/sketch/lustre/element/html.mjs";
import * as $colors from "../../../../ds/colors.mjs";
import * as $text from "../../../../ds/typography/text.mjs";
import { toList, prepend as listPrepend } from "../../../../gleam.mjs";

export function disclosure(attributes, children) {
  let attributes$1 = listPrepend($a.class$("disclosure"), attributes);
  let _pipe = $css.class$(
    toList([
      $css.background($colors.light.grey_50),
      $css.border_radius(px(8)),
      $css.display("flex"),
      $css.flex_direction("column"),
    ]),
  );
  return $html.div(_pipe, attributes$1, children);
}

export function heading_wrapper(attributes, children) {
  let attributes$1 = listPrepend($a.class$("heading-wrapper"), attributes);
  let _pipe = $css.class$(
    toList([
      $css.cursor("pointer"),
      $css.position("sticky"),
      $css.top(px(0)),
      $css.padding_("12px 12px"),
      $css.background($colors.light.grey_50),
      $css.selector(
        "[data-expanded=\"true\"]",
        toList([$css.padding_bottom(px(0))]),
      ),
      $css.selector(
        "[data-disabled=\"true\"]",
        toList([$css.cursor("default")]),
      ),
      $css.selector(
        "[data-disabled=\"true\"] .marker",
        toList([$css.display("none")]),
      ),
      $css.selector(
        "[data-expanded=\"true\"] .marker",
        toList([$css.transform(toList([$transform.rotate($angle.turn(0.5))]))]),
      ),
    ]),
  );
  return $html.div(_pipe, attributes$1, children);
}

export function heading(attributes, children) {
  let attributes$1 = listPrepend($a.class$("heading"), attributes);
  let _pipe = $css.class$(
    toList([
      $css.display("flex"),
      $css.align_items("center"),
      $css.gap(px(8)),
      $css.justify_content("space-between"),
    ]),
  );
  return $html.div(_pipe, attributes$1, children);
}

export function panel_wrapper(attributes, children) {
  let attributes$1 = listPrepend($a.class$("panel-wrapper"), attributes);
  let _pipe = $css.class$(toList([$css.margin(px(12))]));
  return $html.div(_pipe, attributes$1, children);
}

export function panel(attributes, children) {
  let attributes$1 = listPrepend($a.class$("panel"), attributes);
  let _pipe = $css.class$(
    toList([$css.compose($text.xs($text.regular)), $css.white_space("pre-line")]),
  );
  return $html.div(_pipe, attributes$1, children);
}

export function group_wrapper(attributes, children) {
  let attributes$1 = listPrepend($a.class$("group-wrapper"), attributes);
  let _pipe = $css.class$(toList([]));
  return $html.div(_pipe, attributes$1, children);
}

export function group(attributes, children) {
  let attributes$1 = listPrepend($a.class$("group"), attributes);
  let _pipe = $css.class$(toList([]));
  return $html.div(_pipe, attributes$1, children);
}

export function light_separator() {
  let _pipe = $css.class$(
    toList([
      $css.height(px(1)),
      $css.width(percent(100)),
      $css.background($colors.light.grey_200),
      $css.margin_top(px(12)),
    ]),
  );
  return $html.hr(_pipe, toList([]));
}
